/* tslint:disable */
/* eslint-disable */
/**
 * HCL Commerce Transaction server Services 
 * These services provide APIs to interact with transaction
 *
 * The version of the OpenAPI document: 9.1.6
 * 
 * (C) Copyright HCL Technologies Limited 2021
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../../../../../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../../../../../base';
// @ts-ignore
import { ComIbmCommerceRestCatalogHandlerCatalogExportHandlerCatalogExportRequest } from '../../../../../com/hcl/commerce/typescript/axios';
// @ts-ignore
import { ComIbmCommerceRestCatalogHandlerCatalogExportHandlerCatalogExportResponse } from '../../../../../com/hcl/commerce/typescript/axios';
/**
 * CatalogExportApi - axios parameter creator
 * @export
 */
export const CatalogExportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Exports all categories or all products for a store.
         * @param {string} storeId The store identifier.
         * @param {string} objectType Specify the object type to export. Specify Category to export all categories and specify Product to export all products.
         * @param {ComIbmCommerceRestCatalogHandlerCatalogExportHandlerCatalogExportRequest} [body] Specify optional parameters in the body in JSON format. For example, you can specify exportMode, catalogId, langId and CSVColumnList in the body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportCatalogForObjectType: async (storeId: string, objectType: string, body?: ComIbmCommerceRestCatalogHandlerCatalogExportHandlerCatalogExportRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('exportCatalogForObjectType', 'storeId', storeId)
            // verify required parameter 'objectType' is not null or undefined
            assertParamExists('exportCatalogForObjectType', 'objectType', objectType)
            const localVarPath = `/store/{storeId}/catalog_export/{objectType}`
                .replace(`{${"storeId"}}`, String(storeId))
                .replace(`{${"objectType"}}`, String(objectType));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CatalogExportApi - functional programming interface
 * @export
 */
export const CatalogExportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CatalogExportApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Exports all categories or all products for a store.
         * @param {string} storeId The store identifier.
         * @param {string} objectType Specify the object type to export. Specify Category to export all categories and specify Product to export all products.
         * @param {ComIbmCommerceRestCatalogHandlerCatalogExportHandlerCatalogExportRequest} [body] Specify optional parameters in the body in JSON format. For example, you can specify exportMode, catalogId, langId and CSVColumnList in the body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportCatalogForObjectType(storeId: string, objectType: string, body?: ComIbmCommerceRestCatalogHandlerCatalogExportHandlerCatalogExportRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComIbmCommerceRestCatalogHandlerCatalogExportHandlerCatalogExportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportCatalogForObjectType(storeId, objectType, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CatalogExportApi - factory interface
 * @export
 */
export const CatalogExportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CatalogExportApiFp(configuration)
    return {
        /**
         * 
         * @summary Exports all categories or all products for a store.
         * @param {string} storeId The store identifier.
         * @param {string} objectType Specify the object type to export. Specify Category to export all categories and specify Product to export all products.
         * @param {ComIbmCommerceRestCatalogHandlerCatalogExportHandlerCatalogExportRequest} [body] Specify optional parameters in the body in JSON format. For example, you can specify exportMode, catalogId, langId and CSVColumnList in the body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportCatalogForObjectType(storeId: string, objectType: string, body?: ComIbmCommerceRestCatalogHandlerCatalogExportHandlerCatalogExportRequest, options?: any): AxiosPromise<ComIbmCommerceRestCatalogHandlerCatalogExportHandlerCatalogExportResponse> {
            return localVarFp.exportCatalogForObjectType(storeId, objectType, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CatalogExportApi - object-oriented interface
 * @export
 * @class CatalogExportApi
 * @extends {BaseAPI}
 */
export class CatalogExportApi extends BaseAPI {
    /**
     * 
     * @summary Exports all categories or all products for a store.
     * @param {string} storeId The store identifier.
     * @param {string} objectType Specify the object type to export. Specify Category to export all categories and specify Product to export all products.
     * @param {ComIbmCommerceRestCatalogHandlerCatalogExportHandlerCatalogExportRequest} [body] Specify optional parameters in the body in JSON format. For example, you can specify exportMode, catalogId, langId and CSVColumnList in the body.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogExportApi
     */
    public exportCatalogForObjectType(storeId: string, objectType: string, body?: ComIbmCommerceRestCatalogHandlerCatalogExportHandlerCatalogExportRequest, options?: any) {
        return CatalogExportApiFp(this.configuration).exportCatalogForObjectType(storeId, objectType, body, options).then((request) => request(this.axios, this.basePath));
    }
}
